<div class="card theme-{{ theme }} {{ cardClass }}">
  <div class="font-headline-3 align-self-stretch">
    <ng-content select="[card-header]"></ng-content>
  </div>
  <div class="card-body">
    <ng-content></ng-content>
  </div>
  <ng-content select="[card-footer]"></ng-content>
</div>
